import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getClinicDetails, fetchAdmins } from '../utils/apiCalls';
import { useAuth } from '../utils/AuthContext';



export default function PracticeManagementWidget({ clinicId, role }) {
    const { token } = useAuth();
    const navigate = useNavigate();

    const [clinic, setClinic] = useState(null);
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(false);

    const activeAdmins = admins?.filter(admin => admin.is_active) || [];

    useEffect(() => {
        if (!clinicId || !token) return;
        
        const fetchSnapshot = async () => {
            try {
                setLoading(true);
                const [clinicData, adminData] = await Promise.all([
                    getClinicDetails(clinicId, token),
                    fetchAdmins(clinicId, token),
                ]);

                setClinic(clinicData);
                setAdmins(adminData || []);
            } catch (error) {
                console.error('Failed to load practice snapshot', error);
            } finally {
                setLoading(false);
            }
        };
        fetchSnapshot();
    }, [clinicId, token])

    if (!clinicId) {
        return (
            <div className='rounded-lg border border-dashed border-slate-300 p-6 text-center text-slate-500'>
                select a clinic to view practice information
            </div>
        );
    };

    if (loading) {
        return <p className='text-slate-500'>loading clinic summary...</p>
    }

    if (!clinic) return null;

    return (
        <div className='space-y-4'>
            {/* card header  */}
            <div className='flex items-start justify-between'>
                <div>
                    <h3 className='text-lg font-semibold text-slate-800'>
                        {clinic.clinic_name}
                    </h3>
                    <p className='text-xs text-slate-500'>
                        Timezone: {clinic.timezone}
                    </p>
                </div>
                <span className={`text-sm font-semibold ${clinic.is_active ? 'text-green-600' : 'text-red-600'} `}> {clinic.is_active ? 'active' : 'deactivated'}</span>
            </div>

            {/* clinic info  */}
            <div className='grid grid-cols-3 gap-4'>
                {/* locations  */}
                <div className='rounded-lg bg-slate-50 p-4 text-center'>
                    <p className='text-2xl font-bold text-slate-800'>
                        {clinic.locations.length || 0}
                    </p>
                    <p className='text-sm text-slate-500'>{ clinic.locations.length === 1 ? 'Location' : 'Locations' }</p>
                </div>
                {/* admins  */}
                <div className='rounded-lg bg-slate-50 p-4 text-center'>
                    <p className='text-2xl font-bold text-slate-800'>
                        {activeAdmins?.length || 0}
                    </p>
                    <p className='text-sm text-slate-500'> {activeAdmins.length === 1 ? 'Active Clinic Admin' : 'Active Clinic Admins'}</p>
                </div>
                {/* view full details  */}
                <div className='rounded-lg bg-slate-50 p-4 text-center'>
                    <button onClick={() => navigate(`/practice/clinics/${clinicId}`)} className='w-full rounded-lg px-4 py-2 font-semibold text-white voco-gradient-hover shadow-md hover:shadow-docpgr-purple-glow transition'>
                        clinic overview
                    </button>
                </div>
            </div>
        </div>
    )
}